import { createSlice } from '@reduxjs/toolkit';
import axios from 'utils/axios';
// import { dispatch } from 'redux_data/store';
import { getFirstAndLastDateOfWeek } from 'utils/util'; 
import { getSession } from 'utils/jwt';

const [start_date , end_date] = getFirstAndLastDateOfWeek();
const user = getSession();

const slice = createSlice({
  name: 'sales', // This is the name of the slice
  initialState: {
    hasError: null,
    
    isLoading: false,
    isLoadingDetail: false,
    start_date: start_date, 
    end_date: end_date,
    store_id: user?.store_id || "0",
    datas: [],
    data: {},
    // cart:[],
  },
  reducers: {
    noError(state) { // NO ERROR
      state.isLoading = false;
      state.hasError = false;
    },
    unsetError(state) { // UNSET ERROR
      state.hasError = null;
    },
    hasError(state, action) { // HAS ERROR
      state.isLoading = false;
      state.hasError = JSON.stringify(action.payload);
    },
    
    startLoading: (state, action) => {
      state.isLoading = true;
    },
    startLoadingDetail: (state, action) => {
      state.isLoadingDetail = true;
    },
    setStartDate: (state, action) => {
      state.isLoading = false;
      state.start_date = action.payload;
    },
    setEndDate: (state, action) => {
      state.isLoading = false;
      state.end_date = action.payload;
    },
    setStoreId: (state, action) => {
      state.isLoading = false;
      state.store_id = action.payload;
    },
    setDatas: (state, action) => {
      state.isLoading = false;
      state.datas = action.payload;
    },
    setData: (state, action) => {
      state.isLoadingDetail = false;
      state.data = action.payload;
    },
    // setCart: (state, action) => {
    //   state.cart = action.payload;
    // },
  },
});

export const { 
    noError , 
    unsetError , 
    hasError ,
    setDrawerDetailSales, 
    setDrawerDetailExpense,
    startLoading , 
    startLoadingDetail , 
    setStartDate ,
    setEndDate ,
    setStoreId,
    setDatas , 
    setData ,
    setCart ,
} = slice.actions;

export default slice.reducer;

const endpoint = "/sales2"

export function searchData({ data = {} , params = {} } = {data: {} , params: {}}) {
  return async (dispatch, getState) => {
    dispatch(startLoading());
    try {
      const state = getState();
      if(!data?.start_date){ data.start_date = state.sales.start_date} ;
      if(!data?.end_date){ data.end_date = state.sales.end_date} ;
      if(!data?.store_id){ data.store_id = state.sales.store_id} ;
      // console.log({state, data});
      
      let endpointURL = `${endpoint}/search`;
      Object.keys(params).forEach(key => {
        if(endpointURL.includes("?")){
          endpointURL = `${endpointURL}&${key}=${params[key]}`;
        }else{
          endpointURL = `${endpointURL}?${key}=${params[key]}`;
        }
      })
      const response = await axios.post( endpointURL , data )?.then( resp => resp?.data);
      // console.log("searchData", response);
      if(response?.success){
        dispatch(slice.actions.setDatas(response.data));
      }else{
        dispatch(slice.actions.hasError(response));
      }
    } catch (error) {
      if(error?.message){
        dispatch(slice.actions.hasError(error.message));
      }else{
        dispatch(slice.actions.hasError(error));
      }
    }
  };
}

export function addData({formData}) {
  return async (dispatch, getState) => {
    dispatch(startLoading());
    try {
      const response = await axios.post(`${endpoint}`, formData )?.then( resp => resp?.data);
      // console.log("addData", response);
      if(response?.success){
        dispatch(noError());
        // dispatch(searchData());
      }else{
        dispatch(hasError(response));
      }
    } catch (error) {
      if(error?.message){
        dispatch(hasError(error.message));
      }else{
        dispatch(hasError(error));
      }
    }
  };
}

export function editData({id, formData, encryptedPin}) {
  return async (dispatch, getState) => {
    dispatch(startLoading());
    try {
      if(encryptedPin){ axios.defaults.headers.common.pin = encryptedPin; }
      const response = await axios.patch(`${endpoint}`, formData )?.then( resp => resp?.data);
      if(response?.success){
        dispatch(noError());
        dispatch(searchData()); 
      }else{
        dispatch(hasError(response));
      }
    } catch (error) {
      if(error?.message){
        dispatch(hasError(error.message));
      }else{
        dispatch(hasError(error));
      }
    }
  };
}

export function deleteData({item_list, encryptedPin}) {
  return async (dispatch, getState) => {
    dispatch(slice.actions.startLoading());
    try {
      // axios.defaults.headers.post['Content-Type'] = 'multipart/form-data';
      const headers = {"headers":{"Content-Type":"multipart/form-data"}}
      if(encryptedPin){ axios.defaults.headers.common.pin = encryptedPin; }
      const response = await axios.put(`${endpoint}`, { item_list } )?.then( resp => { if(resp?.data){ return resp?.data; }else{ console.log(resp?.data); return null; } });
      if(response?.success){
        dispatch(slice.actions.noError());
        dispatch(searchData());
      }else{
        dispatch(slice.actions.hasError(response));
      }
    } catch (error) {
      if(error?.message){
        dispatch(slice.actions.hasError(error.message));
      }else{
        dispatch(slice.actions.hasError(error));
      }
    }
  };
}

export function setDetail(data) {
  return async (dispatch, getState) => {
    // console.log("setDetail" , data);
    dispatch(startLoadingDetail());
    try {
      dispatch(setData(data))
    } catch (error) {
      console.log(error);
    }
  }
}

// export function setCart(data) {
//   return async () => {
//     try {
//       dispatch(slice.actions.setCart(data))
//     } catch (error) {
//       console.log(error);
//     }
//   }
// }
